export const colors = {
  bg: "#fdfbf6",
  section: "#f6efe1",
  gold: "#a9760e",
  goldText: "#8f640b",
  goldLight: "#e8b04b",
  goldSoft: "#f7e8c8",
  goldBorder: "#e2c584",
  ink: "#1e1c18",
  inkSoft: "#33302a",
  text: "#5c5548",
  muted: "#8a7a63",
  border: "#e8dfcd",
  borderSoft: "#efe6d4",
  borderFaint: "#f3ecdc",
  onDark: "#fdfbf6",
  footerText: "#d9d3c6",
  footerMuted: "#b4a984",
};

export const fonts = {
  title: `Marcellus, "Times New Roman", serif`,
  body: `Karla, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif`,
};

export const radius = {
  sm: "12px",
  md: "16px",
  lg: "20px",
  xl: "24px",
  pill: "999px",
};

export const shadow = {
  card: "0 12px 30px rgba(60, 40, 20, .18)",
  menu: "0 20px 40px rgba(30, 25, 15, .12)",
  lightbox: "0 30px 80px rgba(0, 0, 0, .5)",
};

export const BREAKPOINT = 900;
export const BREAKPOINT_SMALL = 600;

export const bp = {
  mobile: `@media (max-width: ${BREAKPOINT - 1}px)`,
  desktop: `@media (min-width: ${BREAKPOINT}px)`,
  small: `@media (max-width: ${BREAKPOINT_SMALL - 1}px)`,
};

export const gutter = "clamp(20px, 5vw, 56px)";
